$(function () {
    let path = location.pathname
    if (path == "/" || path == "/item/list" || path == "/item/detail") {
        // トップページのみ
        $('footer').css('margin-top', '0');
    }
});